export enum UGCImpressionType {
  FeedPostCard    = 1,
  ArticlePostCard = 2,
}